import React from 'react'
import moment from 'moment'
import List from '../crud/list'
import menuItems from './menuItems'

function formatMembers (val, resource) {
  const {
    include_checked_in_users: checkedIn,
    include_not_checked_in_users: notCheckedIn
  } = resource

  if (checkedIn && notCheckedIn) {
    return 'All'
  } else if (checkedIn) {
    return 'Checked-in'
  } else if (notCheckedIn) {
    return 'Haven\'t checked-in'
  } else {
    return ''
  }
}

function formatStatus (val, resource) {
  const now = new Date()
  const format = 'MMM D, YYYY'
  const start = moment(resource.start_date)
  const end = moment(resource.end_date)

  // @ts-ignore
  if (start > now) {
    return `Starts on ${start.format(format)}`
  // @ts-ignore
  } else if (end > now) {
    return `Expires on ${end.format(format)}`
  } else {
    return `Expired on ${end.format(format)}`
  }
}

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Session', prop: 'session_id', references: 'admin/sessions', referenceProp: 'long_name' },
  { title: 'Group', prop: 'group_id', references: 'admin/groups', referenceProp: 'name' },
  { title: 'Members', prop: '', format: formatMembers, sortable: false },
  { title: 'Status', prop: '', format: formatStatus, sortable: false }
]

const defaults = {
  order: [{ column: 'name', direction: 'desc' }]
}

const CommentBots = (props) => (
  <List
    title='Comment Bots'
    apiPath='admin/comment_bots'
    columns={columns}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
  />
)

export default CommentBots
